import JWT from 'jwt-client';
import { storageKeys } from '../shared/constants';

JWT.defaults.key = storageKeys.token;

export default JWT;



// WEBPACK FOOTER //
// ./src/shared/jwt.js